// member
if ($('.block--download_tabs').length) {
	// Show the first tab and hide the rest
	$('.tabs--left li:first-child').addClass('active');
	$('.tab-content .tab-pane').hide();
	$('.tab-content .tab-pane:first').show();

	// Click function
	$('.tabs--left li').click(function () {
		$('.tabs--left li').removeClass('active');
		$(this).addClass('active');
		$('.tab-content .tab-pane').hide();

		var activeTab = $(this).find('a').attr('href');
		$(activeTab).fadeIn();
		return false;
	});

	$('.tabs--left li').each(function () {
		var activeTab = $(this).find('a').attr('href');

		if (window.location.href.indexOf(activeTab) > 0) {
			$('.tabs--left li').removeClass('active');
			$(this).addClass('active');
			$('.tab-content .tab-pane').hide();
			$(activeTab).fadeIn();
		}
	});

	$('.nav--tabs--mobile').change(function () {
		$('.tab-content .tab-pane').hide();
		var activeTab = $(this).val();
		$(activeTab).fadeIn();
		$('.tabs--left li').removeClass('active');
	});
}


 var eyetoggle = document.createElement('img');
 eyetoggle.setAttribute('class','eye-toggle');
 eyetoggle.setAttribute('src','/wp-content/themes/localmedia/symbols/icon-eye.svg');
 document.addEventListener('click', function(e) {
  var passwordinput = $(e.target).prev()[0];
  if(passwordinput) {
    if(passwordinput.getAttribute('type') == 'password') {
      passwordinput.setAttribute('type','text');
    }
    else {
      passwordinput.setAttribute('type','password');
    }
  }
 }, { passive: false });

 $('.lwa-password-input input').each(function() {
  this.setAttribute('autocomplete','off');
 });
 $('.lwa-password-input').append(eyetoggle);

$(".lwa-password").each(function() {
	// move down:
	var e = $(this);
	e.next().insertBefore(e);
});
$(".lwa-username").each(function() {
	// move down:
	var e = $(this);
	e.next().insertBefore(e);
});

// $('.page-template-page-haendler .lwa-username, .page-template-page-haendler .lwa-password, .page-template-page-haendler .lwa-submit').hide();
// $('.page-template-page-intern a[href="javascript:void(0)"]').hide();

// $( ".lwa-username, .lwa-password, .lwa-submit" ).wrapAll( "<div class='hidden standard--login' />");

// var lang = document.documentElement.lang.slice(0, 2);

// if (lang == 'fr') {
// 	$( "<p class='show--form text-primary cursor-pointer hover:text-primarydark mb-5'>Login sans SSO</p>" ).insertBefore( ".standard--login" );
// 	$( "<p class='hide--form hidden text-primary cursor-pointer hover:text-primarydark mb-5'>Login avec SSO</p>" ).insertBefore( ".standard--login" );
// }
// if (lang == 'it') {
// 	$( "<p class='show--form text-primary cursor-pointer hover:text-primarydark mb-5'>Login senza SSO</p>" ).insertBefore( ".standard--login" );
// 	$( "<p class='hide--form hidden text-primary cursor-pointer hover:text-primarydark mb-5'>Login con SSO</p>" ).insertBefore( ".standard--login" );
// }
// if (lang == 'en') {
// 	$( "<p class='show--form text-primary cursor-pointer hover:text-primarydark mb-5'>Login without SSO</p>" ).insertBefore( ".standard--login" );
// 	$( "<p class='hide--form hidden text-primary cursor-pointer hover:text-primarydark mb-5'>Login with SSO</p>" ).insertBefore( ".standard--login" );
// }
// if (lang == 'de') {
// 	$( "<p class='show--form text-primary cursor-pointer hover:text-primarydark mb-5'>Login ohne SSO</p>" ).insertBefore( ".standard--login" );
// 	$( "<p class='hide--form hidden text-primary cursor-pointer hover:text-primarydark mb-5'>Login mit SSO</p>" ).insertBefore( ".standard--login" );
// }

// $('.show--form').click(function(){
// 	$(this).hide();
// 	$('.hide--form').show();
// 	$('.standard--login').fadeIn();
// })
// $('.hide--form').click(function(){
// 	$(this).hide();
// 	$('.show--form').show();
// 	$('.standard--login').fadeOut();
// })